/**
 * Verse scrolling and highlight animation.
 */

import type { BibleLocation } from '@skjv/common';

/**
 * Scroll to a verse and optionally highlight it with a fade animation.
 */
export function scrollToVerseElement(
  container: HTMLElement,
  location: BibleLocation,
  highlight: boolean,
  setScrollAdjustment: (until: number) => void,
) {
  const verseId = `v-${location.testamentIndex}-${location.bookIndex}-${location.chapterIndex}-${location.verseIndex}`;
  const verseElement = document.getElementById(verseId);
  console.log('[Scroller] scrollToVerse:', { verseId, found: !!verseElement, highlight });

  if (!verseElement) {
    console.warn('[Scroller] Verse element not found:', verseId);
    return;
  }

  setScrollAdjustment(Date.now() + 2000);

  if (highlight) {
    container.querySelectorAll('.verse.highlighted').forEach((el) => {
      el.classList.remove('highlighted');
    });
  }

  verseElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

  if (highlight) {
    observeAndHighlight(container, verseElement);
  }
}

/** Use IntersectionObserver to add highlight once verse is visible, with fallback */
function observeAndHighlight(container: HTMLElement, verseElement: HTMLElement) {
  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
        console.log('[Scroller] Verse now visible, adding highlight');
        observer.disconnect();
        setTimeout(() => {
          verseElement.classList.add('highlighted');
          setTimeout(() => verseElement.classList.remove('highlighted'), 4000);
        }, 500);
      }
    },
    { root: container, threshold: [0.5] },
  );

  observer.observe(verseElement);

  // Fallback if observer never fires
  setTimeout(() => {
    observer.disconnect();
    if (!verseElement.classList.contains('highlighted')) {
      console.log('[Scroller] Fallback: adding highlight');
      verseElement.classList.add('highlighted');
      setTimeout(() => verseElement.classList.remove('highlighted'), 4000);
    }
  }, 1500);
}
